<template>
  <el-dialog class="wx-dialog " :title="title" :visible.sync="options.show" close="cancel" :width="options.width">
    <div class="save-article">
      <el-form :rules="articleForm.is_to_weixin === 1 ?rulesForm : rules" ref="articleForm" :model="articleForm" label-width="100px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="articleForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="同步">
          <el-radio-group v-model="articleForm.is_to_weixin">
            <p class="radio-list">
              <el-radio :label="0">暂不同步</el-radio>
              <el-button type="text" class="icon-txt" icon="el-icon-question"></el-button>
            </p>
            <p class="radio-list">
              <el-radio :label="1" >同步至“互亿无线“ </el-radio>
              <el-button type="text" class="icon-txt" icon="el-icon-question"></el-button>
              <el-button type="text" class="orange-btn">添加公众号</el-button>
            </p>
          </el-radio-group>
        </el-form-item>
        <div v-if="articleForm.is_to_weixin===1">
          <el-form-item label="作者" prop="author">
            <el-input v-model="articleForm.author" placeholder="请天写文章作者"></el-input>
          </el-form-item>
          <el-form-item label="摘要" prop="abstract">
            <el-input type="textarea" v-model="articleForm.abstract" placeholder="如留空，系统将自动取正文的前54个字符"></el-input>
          </el-form-item>
          <el-form-item label="封面">
            <el-radio-group v-model="articleForm.img_type">
              <el-radio :label="1">首图文</el-radio>
              <el-button type="text" class="icon-txt" icon="el-icon-question"></el-button>
              <el-radio :label="2" style="margin-left:30px">次图文</el-radio>
              <el-button type="text" class="icon-txt" icon="el-icon-question"></el-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item >
            <div v-if="articleForm.img" :class="articleForm.img_type === 1 ? 'imgPic home-pic' : 'imgPic other-pic'">
              <img :src="articleForm.img" />
            </div>
            <div class="save-btn-list">
              <el-button type="info">编辑首图</el-button>
              <el-button type="info" @click="choosePic">从图库选择</el-button>
              <el-button type="info">本地上传</el-button>
              <span class="warn-info">{{picTxt}}</span>
            </div>
          </el-form-item>
          <el-form-item >
            <p class="radio-list">
              <el-checkbox :value="1" v-model="articleForm.is_show_img">正文顶部显示封面图</el-checkbox>
              <el-button type="text" class="icon-txt" icon="el-icon-question"></el-button>
            </p>
            <p class="radio-list">
              <el-checkbox :value="2" v-model="articleForm.is_show_link">原文链接 </el-checkbox>
              <el-button type="text" class="icon-txt" icon="el-icon-question"></el-button>
              <el-input v-if="articleForm.is_show_link" v-model="articleForm.link" placeholder="http://"></el-input>
            </p>
            <div class="radio-list">
              <el-checkbox :value="3" v-model="articleForm.is_open_comment">开启留言 </el-checkbox>
              <div class="msg-list">
                <el-checkbox-group :max="1" v-model="articleForm.comment_man" v-if="articleForm.is_open_comment">
                  <el-checkbox  :label="0">所有人可留言</el-checkbox>
                  <el-checkbox  :label="1">仅关注后可留言</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="footer-dialog-article" style="text-align:center;">
      <el-button type="success"  @click="submit('articleForm', 3)" v-if="metaData.obj && metaData.obj.id">覆盖原图文</el-button>
      <el-button type="success"  @click="submit('articleForm', 4)">另存为新图文</el-button>
      <el-button type="success"  @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ArticleService from '@/service/api/articleService'
import _ from 'lodash'

export default {
  props: {
    metaData: {
      type: Object,
      default: {}
    },
    cancelFn: {
      type: Function,
      default: () => undefined
    },
    submitFn: {
      type: Function,
      default: () => undefined
    },
    options: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      msgCheck: true,
      pic: null,
      articleForm: {
        title: null,
        abstract: null,
        is_to_weixin: 1,
        img_type: 1,
        img: null,
        weixinid: null,
        link: null,
        is_show_img: false,
        is_show_link: false,
        is_open_comment: false,
        author: null,
        comment_man: [0]
      },
      rulesForm: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' },
          { min: 1, max: 64, message: '长度不能超过64个字', trigger: 'blur' }
        ],author: [
          { min: 1, max: 8, message: '长度不能超过8个字', trigger: 'blur' }
        ],abstract: [
          { min: 1, max: 120, message: '长度不能超过120个字', trigger: 'blur' }
        ]
      },
      rules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' },
          { min: 1, max: 64, message: '长度不能超过64个字', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    created() {
      if (this.metaData.obj && this.metaData.obj.content) {
        this.articleForm.content = this.metaData.obj.content
      }
    },
    chooseData (val) {
      if (val) this.articleForm.img = val
    },
    choosePic () {
      this.$edit.open('myGallery', '我的图库', {}, { width: '860px', show: true }, this.chooseData.bind(this) )
    },
    submit (formName, val) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const obj = {
            is_show_img: this.articleForm.is_show_img ? 1 : 0,
            is_show_link: this.articleForm.is_show_link ? 1 : 0,
            is_open_comment: this.articleForm.is_open_comment ? 1 : 0,
            type: 1
          }
          if (val === 3) obj.id = this.metaData.id
          const params = Object.assign(this.articleForm, obj)
          console.log(params)
          const articleSystem = new ArticleService()
          articleSystem.saveArticles(this.articleForm)
            .then(() => {
              this.$destroy()
            }, (error) => {
            this.$notify.error(error.message)
            })
        }
      })
    },

    cancel () {
      if (this.cancelFn && typeof this.cancelFn === 'function') {
        this.cancelFn()
      }
      this.$destroy()
    }
  },

  computed: {
    picTxt () {
      const txt = this.articleForm.home === 1 ? '建议尺寸900 * 300像素' : '建议尺寸200 * 200像素'
      return txt
    }
  },

  destroyed () {
    document
      .getElementById('app')
      .removeChild(this.$el)
  }
}
</script>

<style lang="scss" scoped>
.save-article{
  margin-top: 20px;
  .el-input, .el-textarea{
    width: 452px;
  }
  .radio-list{
    display: flex;
    align-items: center;
    margin-top: 15px;
    &:first-child{
      margin-top: 0;
    }
    .orange-btn{
      color: #ff7011
    }
    .msg-list{
      height: 40px;
      margin-left: 30px;
    }
  }
  .icon-txt{
    color: #d6d6d6;
    margin: 0 10px;
  }
  .warn-info{
    color: #d6d6d6;
    margin-left: 10px;
  }
  .imgPic{
    border: solid 1px #ccc;
    margin-bottom: 22px;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .home-pic{
    max-height: 100px;
    max-width: 300px;
  }
  .other-pic {
    width: 100px;
    height: 100px;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/dialog/saveArticle.vue